import axios from 'axios'
import { host, imageHost } from '../../helper/config'
import { ITEM_PER_PAGE } from '../../helper/helper'

const PLUGINS_NAME = 'admin-banners'

export const getAll = async (token, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get`, {
        page: page,
        itemPerPage: ITEM_PER_PAGE
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}

export const update = async (token, id, image, status) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/update`, {
        id: id,
        image: image,
        status: status
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}

export const add = async (token, image, status, index) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/add`, {
        image: image,
        status: status,
        ...(index !== undefined && index !== null && !Number.isNaN(index) ? { index } : {})
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}

export const updateIndex = async (token, id, index) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/update-index`, {
        id: id,
        index: index
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}

export const deleteBanner = async (token, id) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/delete`, {
        id: id
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return false
}


export const getUploadToken = async (token) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/upload-token`, {}, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })
    return (response && response.status === 200 && response.data && response.data.token) || ''
}

export const uploadBanner = async (token, image, filename) => {
    const uploadToken = await getUploadToken(token)

    let bodyFormData = new FormData();
    bodyFormData.append('image', image);
    bodyFormData.append('filename', filename);
    bodyFormData.append('token', uploadToken);

    const response = await axios.post(`${imageHost}/upload_ad`, bodyFormData, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'multipart/form-data',
        },
    })

    return !!(response && response.status === 200 && response.data && response.data.status)
}